/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Hide the trailing " ***" marker that some variant names use (e.g. "5-Pack ***").
  // Only visible text is changed — form input values and data attributes are left
  // untouched so variant selection / add-to-cart keep matching the real option value.
  var ASTERISK_RE = /\s*\*\*\*/g;
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1 };

  function cleanTextNodes(root) {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      if (root.nodeValue.indexOf('***') !== -1) {
        root.nodeValue = root.nodeValue.replace(ASTERISK_RE, '');
      }
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node) {
        if (node.nodeValue.indexOf('***') === -1) return NodeFilter.FILTER_REJECT;
        if (node.parentNode && SKIP_TAGS[node.parentNode.nodeName]) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    var batch = [];
    while ((node = walker.nextNode())) batch.push(node);
    batch.forEach(function(n) { n.nodeValue = n.nodeValue.replace(ASTERISK_RE, ''); });
  }

  function run() {
    cleanTextNodes(document.body);

    // Re-clean content injected after load (variant swaps, cart drawer, quick view, etc.).
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) cleanTextNodes(added[j]);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) {
    run();
  } else {
    document.addEventListener('DOMContentLoaded', run);
  }


  // ===== Minimum order value =====
  // Blocks checkout (cart drawer + cart page) when the cart subtotal is under
  // the minimum, and shows a popup instead. Total is re-fetched from /cart.js
  // at click time so a stale drawer can't sneak an under-minimum order through.
  // Checkout runs through Navidium's injected buttons (#nvd-with-checkout-btn /
  // #nvd-without-checkout-btn), which navigate via JS instead of submitting the
  // cart form — so those clicks are intercepted directly, with the form-submit
  // guard kept as a fallback for when Navidium is disabled.
  var MIN_ORDER_CENTS = 16900; // $169.00
  var MIN_ORDER_MESSAGE = 'We require a minimum order of $169. Please add additional items to your order before checking out.';
  var NAVIDIUM_BUTTONS = '#nvd-with-checkout-btn, #nvd-without-checkout-btn';

  var minOrderPassed = false;
  var minOrderModal = null;

  function buildMinOrderModal() {
    if (minOrderModal) return minOrderModal;

    minOrderModal = document.createElement('div');
    minOrderModal.className = 'min-order-modal';
    minOrderModal.setAttribute('hidden', '');
    minOrderModal.innerHTML =
      '<div class="min-order-modal__overlay" data-min-order-close></div>' +
      '<div class="min-order-modal__content" role="dialog" aria-modal="true" aria-label="Minimum order required">' +
        '<p class="min-order-modal__message">' + MIN_ORDER_MESSAGE + '</p>' +
        '<button type="button" class="btn min-order-modal__button" data-min-order-close>Continue shopping</button>' +
      '</div>';

    minOrderModal.addEventListener('click', function(e) {
      if (e.target.hasAttribute('data-min-order-close')) closeMinOrderModal();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !minOrderModal.hasAttribute('hidden')) closeMinOrderModal();
    });

    document.body.appendChild(minOrderModal);
    return minOrderModal;
  }

  function openMinOrderModal() {
    var modal = buildMinOrderModal();
    modal.removeAttribute('hidden');
    var button = modal.querySelector('.min-order-modal__button');
    if (button) button.focus();
  }

  function closeMinOrderModal() {
    if (minOrderModal) minOrderModal.setAttribute('hidden', '');
  }

  // The Navidium shipping-protection line item shouldn't count toward the
  // product minimum (and it may not even be in the cart yet at click time).
  function cartTotalExcludingProtection(cart) {
    var total = cart.total_price;
    (cart.items || []).forEach(function(item) {
      var haystack = [item.handle, item.vendor, item.product_title].join(' ');
      if (/navidium|shipping[ -]?protection/i.test(haystack)) {
        total -= item.final_line_price != null ? item.final_line_price : item.line_price;
      }
    });
    return total;
  }

  // Fetches the live cart and either runs onPass or shows the popup.
  // Fails open (runs onPass) if the cart can't be fetched, so a network
  // hiccup never blocks a sale.
  function checkMinOrder(onPass) {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        if (cartTotalExcludingProtection(cart) >= MIN_ORDER_CENTS) {
          onPass();
        } else {
          openMinOrderModal();
        }
      })
      .catch(onPass);
  }

  // Navidium's buttons: block the click before Navidium's own handler runs,
  // then re-dispatch it (flag set) once the minimum check passes.
  document.addEventListener('click', function(e) {
    var btn = e.target.closest ? e.target.closest(NAVIDIUM_BUTTONS) : null;
    if (!btn) return;

    if (minOrderPassed) {
      minOrderPassed = false;
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    checkMinOrder(function() {
      minOrderPassed = true;
      btn.click();
    });
  }, true);

  // Fallback: the theme's own cart form submit (drawer and cart page both
  // submit via the button named "checkout") for when Navidium isn't active.
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;

    var submitter = e.submitter;
    var isCheckout = submitter && submitter.name === 'checkout';
    if (!isCheckout) {
      var action = form.getAttribute('action') || '';
      isCheckout = /\/cart\/?$/.test(action.split('?')[0]) && form.querySelector('[name="checkout"]') !== null;
    }
    if (!isCheckout) return;

    if (minOrderPassed) {
      minOrderPassed = false;
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    checkMinOrder(function() {
      minOrderPassed = true;
      if (form.requestSubmit) {
        form.requestSubmit(submitter || undefined);
      } else {
        form.submit();
      }
    });
  }, true);


    /*
    Drop-in bridge for the new .navlink__toggle button.
    Use this ONLY if you can't easily edit your theme's <hover-disclosure> class.

    It keeps the button's aria-expanded in sync with whatever open/close state
    your theme already applies to the <hover-disclosure> element (usually an
    is-active / is-open class), and makes the button toggle that state on click,
    Enter and Space -- so keyboard users get the same menu mouse users get.

    OPEN_CLASS is set to the class this theme actually toggles ('is-visible').
  */
  (function () {
    // Verified against the theme: HoverDisclosure.showDisclosure() in theme.js adds
    // 'is-visible' to the <hover-disclosure> element, and theme.css keys the dropdown
    // off `.menu__item.is-visible .header__dropdown`. Using any other name here means
    // the click toggle does nothing visually and aria-expanded never tracks hover/focus.
    var OPEN_CLASS = 'is-visible';

    function init(host) {
      var toggle = host.querySelector(':scope > [data-nav-toggle]');
      if (!toggle || toggle.dataset.bridged) return;
      toggle.dataset.bridged = 'true';

      function sync() {
        toggle.setAttribute('aria-expanded', String(host.classList.contains(OPEN_CLASS)));
      }

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        host.classList.toggle(OPEN_CLASS);
        sync();
      });

      // Close on Escape while focus is inside this item
      host.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && host.classList.contains(OPEN_CLASS)) {
          host.classList.remove(OPEN_CLASS);
          sync();
          toggle.focus();
        }
      });

      // Mirror hover/focus opens that the theme performs itself
      new MutationObserver(sync).observe(host, {
        attributes: true,
        attributeFilter: ['class']
      });

      sync();
    }

    function initAll() {
      document.querySelectorAll('hover-disclosure').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Shopify theme editor re-renders sections
    document.addEventListener('shopify:section:load', initAll);
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


